/*
 * @Date: 2023-01-13 13:11:39
 * @Author: pengling pengling@piesat.cn
 * @Description: 污染源数据配置文件
 */

// 污染源清单类型
class TypeKeys {
  regionId = ''

  value :any= {}

  static readonly baseKeys = {
    headers: {},
    others: {
      isSupervise: '是否有监控手段',
    },
    book: {},
  }

  static readonly regionConfig = {
    // 高淳
    320125000000: {
      common: {
        headers: {
          code: '污染源编号',
          area: '区域',
          illegalnum: '违规次数（本年）',
        },
        book: {
          firstPerson: {
            label: '一级联系人   企业负责人',
            phoneKey: 'firstPhone',
          },
          secondPerson: {
            label: '二级联系人   属地负责人',
            phoneKey: 'secondPhone',
          },
          thirdPerson: {
            label: '三级联系人   管理部门',
            phoneKey: 'thirdPhone',
          },
        },
      },
      typeKeys: [
      // 1-工业企业
        {
          key: '1',
          // 表头
          headers: {
            name: '企业名称',
            address: '地址',
            companyType: '行业类别',
            mainPollutantsType: '主要大气污染物类型',
          },
          // 其它数据-详情页需要
          others: {
            isLinkToMonitor: '是否有自动监控',
            isLinkToElec: '是否有企业配电',
            lon: '经度',
            lat: '纬度',
          },
        },
        // 2-汽修行业
        {
          key: '2',
          headers: {
            name: '企业名称',
            socialCreditCode: '统一社会信用代码',
            address: '地址',
            enterpriseLegalPerson: '企业法人',
          },
          others: {
            isLinkToReplace: '是否有码上换',
            lon: '经度',
            lat: '纬度',
          },
        },
        // 3-餐饮油烟
        {
          key: '3',
          headers: {
            companyName: '单位名称',
            address: '地址',
            operatingArea: '经营面积(m²)',
            lineMonitor: '有无在线监控',
            remark: '备注',
          },
          others: {
            isLinkToWash: '是否有码上洗',
          },
        },
        // 4-锅炉
        {
          key: '4',
          headers: {
            companyName: '企业名称',
            companyType: '行业类别',
            boilerType: '锅炉类型',
            boilerNumber: '台数',
            power: '功率/吨位',
            fuelType: '燃料类型',
            fuelAmount: '燃料年使用量（吨/万方）',
            handleDevice: '废气处理设施',
            handleTechnics: '处理工艺',
          },
          others: {
            address: '地址',
          },
        },
        // 5-干洗行业
        {
          key: '5',
          headers: {
            companyName: '企业名称（营业执照)',
            businessArea: '营业面积/m2',
            washerType: '干洗机类型',
            washerNumber: '数量',
            washerModel: '型号',
            solventType: '干洗溶剂类型',
            isMonitor: '是否安装在线监测',
          },
          others: {
            companyType: '企业店招',
            address: '地址',
          },
        },
        // 6-建设工地
        {
          key: '6',
          headers: {
            name: '项目名称',
            category: '类别',
            deportment: '行业主管部门',
            managementUnit: '项目管理单位',
            projectSchedule: '项目形象进度(场地平整、土方开挖、基础施工、主体施工、室外施工、扫尾）',
            isSmartSite: '是否为智慧工地',
            isManageSite: '是否为差别化管理工地',
            isPublicity: '是否落实八达标两承诺一公示',
            constructUnit: '施工单位',
          },
          others: {
            lon: '经度',
            lat: '纬度',
          },
        },
        // 8-堆场
        {
          key: '8',
          headers: {
            name: '现存砂石物料堆场名称',
            address: '地址',
            landBody: '土地性质',
          },
          others: {
            lon: '经度',
            lat: '纬度',
          },
        },
        // 9-加油站
        {
          key: '9',
          headers: {
            type: '类别',
            name: '加油站名称',
            socialCreditCode: '统一社会信用代码',
            address: '地址',
            companyType: '企业类型',
            oneTimeRecovery: '一次回收',
            secondaryRecovery: '二次回收',
            tripleRecovery: '三次回收',
            installed: '是否安装油气回收在线监测系统',
          },
          others: {
            lon: '经度',
            lat: '纬度',
          },
        },
        // 10-停车场
        {
          key: '10',
          headers: {
            name: '停车场名称',
            address: '地址',
            measure: '面积(m²)',
            responsibleUnit: '责任单位',
            lineMonitor: '是否安装在线监测',
            remark: '备注',
          },
          others: {
            lon: '经度',
            lat: '纬度',
          },
        },
        // 12-用车大户
        {
          key: '12',
          headers: {
            company: '运输企业',
            companyName: '运输企业名称',
            address: '停车场地址',
            lineMonitor: '是否有监控',
            remark: '备注',
          },
          others: {
            lon: '经度',
            lat: '纬度',
          },
        },
      ],
    },
    // 焦作
    410800000000: {
      common: {
        headers: {
          area: '区域',
        },
        others: {
          address: '地址',
          lon: '经度',
          lat: '纬度',
        },
      },
      typeKeys: [
        // 1-工业企业
        {
          key: '1',
          headers: {
            area: '辖区',
            name: '单位名称',
            companyType: '行业',
          },
        },
        // 2-汽修行业
        {
          key: '2',
          headers: {
            area: '辖区',
            name: '单位名称',
            waterPaintDosage: '每年水性漆用量Kg',
            oilPaintDosage: '每年油性漆用量Kg',
            pollutionControlFacilities: '污染治理设施',
            dosage: '活性炭用量',
            replacementFrequency: '活性炭更换频次',
          },
          others: {
            isPaintingRoom: '是否有喷漆房',
            isTrade: '是否营业',
            remark: '备注',
          },
          book: {
            firstPerson: {
              label: '单位环保负责人员',
              phoneKey: 'firstPhone',
            },
          },
        },
        // 3-餐饮油烟
        {
          key: '3',
          headers: {
            area: '辖区',
            companyName: '单位名称',
            fuel: '所用燃料',
            operatingArea: '建筑面积',
            num: '基准灶头数',
          },
          others: {
            facilityModel: '油烟净化设施名称型号',
            manufacturer: '油烟净化设施生产厂家',
            cleaningFrequency: '油烟净化设施清洗频次',
            chimneyHeight: '烟囱高度（米）',
            isNetworking: '是否安装油烟在线并与城管部门联网',
            isTrade: '是否营业',
            streetOpinions: '备注',
          },
          book: {
            firstPerson: {
              label: '门店环保负责人员',
              phoneKey: 'firstPhone',
            },
          },
        },
        // 4-锅炉
        {
          key: '4',
          headers: {
            area: '地区(区/县）',
            name: '企业名',
            companyType: '行业',
            code: '锅炉编号',
            usePermitCode: '使用证编号',
            boilerNumber: '锅炉规模',
          },
          others: {
            fuelType: '燃料类型',
            coalConsumption: '燃煤消耗量',
            fuelConsumption: '燃油消耗量',
            biomassConsumption: '生物质消耗量',
            gasConsumption: '天然气消耗量',
            otherConsumption: '其他能源年消耗量',
            desulfurizationFacilities: '脱硫设施',
            denitrationFacilities: '脱硝设施',
            dustFacilities: '除尘设施',
            transformationTime: '完成超低排放改造时间',
            isInstallOnline: '是否安装在线',
            isNetworking: '是否联网',
            useTo: '用途',
            runStatus: '运行状态',
            remark: '备注',
          },
          book: {},
        },
        // 6-工地扬尘
        {
          key: '6',
          headers: {
            area: '区域',
            name: '项目名称',
            buildUnit: '建设单位',
            constructUnit: '施工单位',
            cover: '占地面积（m2)',
            existingProblems: '存在问题',
          },
          others: {
            implementation: '六个百分之百落实情况',
            earthworkEstimatedTime: '土石方作业预计完成时间',
            engineeringEstimatedTime: '工程作业预计完成时间',
            deportment: '行业主管单位',
            remark: '备注',
          },
          book: {
            firstPerson: {
              label: '监管责任人',
              phoneKey: 'firstPhone',
            },
          },
        },
        // 11-工业炉窑
        {
          key: '11',
          headers: {
            area: '地区',
            name: '企业名',
            industryType: '行业类别',
            furnaceType: '炉窑类型',
            furnaceChildType: '炉窑子类',
            furnaceOverallScope: '该类炉窑总规模',
            annualFuelConsumption: '主要燃料年消耗量',
            isMonitor: '是否安装自动监控设施',
            isNetworking: '是否联网',
          },
          others: {
            furnaceNumber: '炉窑编号',
            furnaceNum: '该类炉窑个数',
            scaleUnit: '规模单位',
            fuelType: '燃料类型',
            fuelUnit: '燃料单位',
            desulfurizationFacilities: '脱硫设施',
            denitrationFacilities: '脱硝设施',
            dustFacilities: '除尘设施',
          },
          book: {},
        },
      ],
    },
  }

  constructor (regionId:string) {
    this.setTypeKeysByRegion(regionId);
  }

  setTypeKeysByRegion (regionId:string) :void{
    this.value = TypeKeys.regionConfig[regionId] || {};
    this.regionId = regionId;
  }

  // 根据污染源类型获取清单配置
  getKeysByType (type:string) :any {
    const { common,typeKeys, } = this.value;
    const keys = typeKeys?.find((item:any) => item?.key === type);

    return {
      key: type,
      headers: { ...TypeKeys.baseKeys?.headers,...common?.headers,...keys?.headers, },
      others: { ...TypeKeys.baseKeys?.others,...common?.others,...keys?.others, },
      book: { ...TypeKeys.baseKeys?.book,...common?.book,...keys?.book, },
    };
  }
}

// 在线监测-详情
export const typeMonKeys = {
  name: '企业名称',
  street: '区域',
  industryName: '行业',
  lon: '经度',
  lat: '纬度',
  businessArea: '面积',
  detailAddress: '地址',
};

// 在线监测-企业列表

// 企业列表默认配置
export const defaultSortLists = {
  component: 'baseLists',
  sortLists: [
    {
      name: '企业名称',
      value: 'companyName',
    },
  ],
};
// 企业列表特殊类型配置
export const onlineTypeLists :any = [
  {
    param: '1',
    children: [
      {
        name: 'CEMS在线监测',
        key: 'companyList',
        param: 'CEMS',
        component: 'companyLists',
        id: '1-1',
        sortLists: [
          {
            name: '企业名称',
            value: 'companyName',
          },
          {
            name: '烟尘浓度',
            value: 'dust',
          },
          {
            name: '烟尘浓度环比',
            value: 'dustTrend',
          },
          {
            name: 'SO₂浓度',
            value: 'so2',
          },
          {
            name: 'SO₂浓度环比',
            value: 'so2Trend',
          },
          {
            name: 'NOx浓度',
            value: 'nox',
          },
          {
            name: 'NOx浓度环比',
            value: 'noxTrend',
          },
          {
            name: '氧含量',
            value: 'o2',
          },
          {
            name: '氧含量环比',
            value: 'o2Trend',
          },
          {
            name: '末次监测时间',
            value: 'createTime',
          },
        ],
      },
      {
        name: 'VOC在线监测',
        key: 'companyList',
        param: 'VOC',
        id: '1-2',
        component: 'companyLists',
        sortLists: [
          {
            name: '企业名称',
            value: 'companyName',
          },
          {
            name: 'TVOC浓度',
            value: 'tvoc',
          },
          {
            name: 'TVOC环比',
            value: 'tvocTrend',
          },
          {
            name: '氧含量',
            value: 'o2',
          },
          {
            name: '氧含量环比',
            value: 'o2Trend',
          },
          {
            name: '末次监测时间',
            value: 'createTime',
          },
        ],
      },
      {
        name: '企业配电',
        key: 'electric',
        param: 'electric',
        component: 'electricLists',
        id: '1-3',
        sortLists: [
          {
            name: '日用电量',
            value: 'accumulativeValue',
          },
        ],
      },
      {
        name: '视频监控',
        param: '1',
        key: 'company_camera',
        component: 'baseLists',
        id: '1-4',
        sortLists: [
          {
            name: '企业名称',
            value: 'companyName',
          },
        ],
      },
    ],
  },
  {
    param: '3',
    component: 'cookLists',
    sortLists: [
      {
        name: '企业名称',
        value: 'cookName',
      },
      {
        name: '颗粒物',
        value: 'particleCon',
      },
      {
        name: '颗粒物浓度环比',
        value: 'particleConPer',
      },
      {
        name: '油烟浓度',
        value: 'density',
      },
      {
        name: '油烟浓度环比',
        value: 'densityPer',
      },
      {
        name: '非甲烷总烃',
        value: 'wasteGas',
      },
      {
        name: '非甲烷总烃环比',
        value: 'wasteGasPer',
      },
      {
        name: '末次监测时间',
        value: 'createTime',
      },
    ],
    defaultSort: 'density',
  },
];

export const unitType = [{
  label: '颗粒物',
  mainKey: 'particleCon',
  trendKey: 'particleConPer',
  unit: 'mg/m³',
},
{
  label: '油烟',
  mainKey: 'density',
  trendKey: 'densityPer',
  unit: 'mg/m³',
},
{
  label: '非甲烷总烃',
  mainKey: 'wasteGas',
  trendKey: 'wasteGasPer',
  unit: 'mg/m³',
},
{
  label: 'TSP',
  mainKey: 'tsp',
  trendKey: 'tspTrend',
  unit: 'mg/m³',
},
{
  label: 'PM₂.₅',
  mainKey: 'pm25',
  trendKey: 'pm25Trend',
  unit: 'mg/m³',
},
{
  label: 'PM₁₀',
  mainKey: 'pm10',
  trendKey: 'pm10Trend',
  unit: 'mg/m³',
},
{
  label: '温度',
  mainKey: 'tem',
  trendKey: 'temTrend',
  unit: '℃³',
},
{
  label: '风速',
  mainKey: 'windS',
  trendKey: 'windSTrend',
  unit: 'm/s',
},
{
  label: '烟尘',
  mainKey: 'dust',
  trendKey: 'dustTrend',
  unit: 'mg/m³',
},
{
  label: 'SO₂',
  mainKey: 'so2',
  trendKey: 'so2Trend',
  unit: 'ppm',
},
{
  label: 'NOx',
  mainKey: 'nox',
  trendKey: 'noxTrend',
  unit: 'ppm',
},
{
  label: '氧含量',
  mainKey: 'o2',
  trendKey: 'o2Trend',
  unit: '%',
},
{
  label: '废气量',
  mainKey: 'tvoc',
  trendKey: 'tvocTrend',
  unit: 'm³',
},];

// 获取清单展示字段（表格+详情)
export const getShowKeysByType = (() => {
  let instance :null|TypeKeys = null;

  return (tableType:string,dataType:string,regionId?:string) => {
    if (!instance || instance.regionId !== regionId) {
      instance = new TypeKeys(regionId ?? '');
    }
    // tableType （堆场返参8.1，特殊处理类似值）
    const types = tableType.split('.');
    // 一级类型
    const type1 = types[0];
    // 二级类型（暂时未使用）
    const type2 = dataType || types[1];

    return instance.getKeysByType(type1);
  };
}
)();

// 通知下发

// 信息类型
export const messageTypes = [
  { label: '监测告警信息',value: '监测告警信息', },
  { label: '违规信息',value: '违规信息', },
  { label: '其它',value: '其它', },
];

// 联系人类型
export const personTypes = [
  'firstPerson',
  'secondPerson',
  'thirdPerson',
];
